// The one path contract the client and server share for generated image previews: the backend
// writes a preview here, and the source list reads it from here before falling back to the
// original. The preview spec itself (size, quality, cache headers) is server-only and lives with
// the pipeline in apps/backend.
export const getImagePreviewStoragePath = (source: string): string => {
  const separatorIndex = source.lastIndexOf('/');
  const directory = separatorIndex >= 0 ? source.slice(0, separatorIndex) : '';
  const fileName = source.slice(separatorIndex + 1);

  return `${directory ? `${directory}/` : ''}previews/${fileName}.webp`;
};
